import { psAxios } from '@patsnap/common-ps-http';
import {
    createEurekaPageViewReporter,
    createTrackingTime,
    type TrackingTimeTracker,
} from '@patsnap/tracking-time';
import { useInitData } from '@/composables/ai/use-init-data';
import router from '@/routers';

const DEFAULT_AGENT_NAME = 'tech_qa';

let trackingTime: TrackingTimeTracker | null = null;
let removeRouterAfterEach: (() => void) | null = null;

function handleTrackingTimeError(error: unknown): void {
    console.error('[Tracking time] Failed to track page view', error);
}

export function initializeTrackingTime(): void {
    if (trackingTime) return;

    const { currentAgent } = useInitData();

    try {
        trackingTime = createTrackingTime({
            autoTrackRouteChanges: false,
            reportPageView: createEurekaPageViewReporter({
                axios: psAxios,
                baseUrl: import.meta.env.VITE_EUREKA_SERVICE_URI,
                getProductLine: () => 'eureka_rd',
                getAgentName: () => currentAgent.value?.code || DEFAULT_AGENT_NAME,
            }),
            onError: handleTrackingTimeError,
        });
    } catch (error) {
        handleTrackingTimeError(error);
        return;
    }

    let currentPageFullPath = window.location.href;
    removeRouterAfterEach = router.afterEach(() => {
        const nextPageFullPath = window.location.href;
        if (nextPageFullPath === currentPageFullPath) return;

        currentPageFullPath = nextPageFullPath;
        trackingTime?.restartPageView();
    });
}

async function disposeTrackingTime(): Promise<void> {
    removeRouterAfterEach?.();
    removeRouterAfterEach = null;

    const tracker = trackingTime;
    trackingTime = null;
    await tracker?.destroy();
}

if (import.meta.hot) {
    import.meta.hot.dispose(disposeTrackingTime);
}
